import {SpyneTrait, DomElement, ViewStream, DomElementTemplate} from 'spyne';
import { UtilTraits } from "traits/util-traits";

export class CodePlaygroundExamplesReferencesTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "codeplaygroundRef$";

    super(context, traitPrefix);
  }

  static codeplaygroundRef$Default(name = "test") {
    const vs = new ViewStream({ data: "Hello World " + name });
    vs.appendToDom(this.props.el.contentDocument.body);

    return `
       new ViewStream({data: "Hello World"})
       .appendToDom(document.body);
       
       // ${name}

    `;
  }

  static codeplaygroundRef$ViewStreamConstructor(props = this.props) {
    const name = this?.props?.data?.name;
    //  return this.codeplaygroundRef$Default(name);

    const vs = new ViewStream({ data: "Hello World" });
    vs.appendToDom(this.props.el.contentDocument.body);

    function replaceHyphensWithHtmlDashes(str) {
      return str.replace(/-/g, "&#8209;");
    }

    let outerHTML = UtilTraits.util$EscapeHTMLChars(vs.props.el.outerHTML);

    outerHTML = replaceHyphensWithHtmlDashes(outerHTML);

    let outerComment = UtilTraits.util$EscapeHTMLChars("<!--OUTPUT-->");
    outerComment = replaceHyphensWithHtmlDashes(outerComment);

    const outerDomEl = new DomElement({
      template: `<p class="code-sample">${outerComment}<br/>${outerHTML}</p>`,
    });

    // vs.props.el.appendChild(outerDomEl.render());

    return `
    import { ViewStream } from 'spyne';
    
    // Simple "Hello World" view
    const myView = new ViewStream({
      data: 'Hello World'
    });
    
    // Insert into DOM
    myView.appendToDom(document.body);
           
    `;
  }

  static codeplaygroundRef$ViewStreamAppendView(props = this.props) {
    class Box extends ViewStream {
      constructor(props = {}) {
        props.tagName = "li";
        props.style = `padding:.5rem;
        margin: .5rem 0;
        background:${props.bg}`;
        super(props);
      }
    }

    const parentVS = new ViewStream({
      tagName: "ul",
      style:
        "border:1px solid midnightblue;padding:.25rem .5rem; list-style-type:none;",
    });

    parentVS.appendToDom(this.props.el.contentDocument.body);

    parentVS.appendView(new Box({ data: "appendView +", bg: "deepskyblue" }));

    return `   class Box extends ViewStream{
      constructor(props={}) {
        props.tagName="li";
        props.style=\`padding:.5rem;
        \u200Bmargin: .5rem 0;
        \u200Bbackground:$\u200B{props.bg};\`
        super(props);
      }
    }
    
    const parentVS = new ViewStream({
      tagName: 'ul',
      style: 'border:1px solid #666;'
    })
    
    parentVS.appendToDom(document.body);
    
    parentVS.appendView(new Box(
        {data:'appendView +',
         bg:"deepskyblue"}))

    `;
  }

  static codeplaygroundRef$ViewStreamAppendViewOld(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamAppendViewAfter(props = this.props) {
    class Box extends ViewStream {
      constructor(props = {}) {
        props.tagName = "li";
        props.style = `padding:.5rem;
        margin: .5rem 0;
        background:${props.bg}`;
        super(props);
      }
    }

    const parentVS = new ViewStream({
      tagName: "ul",
      style:
        "border:1px solid midnightblue;padding:.25rem .5rem; list-style-type:none;",
    });

    parentVS.appendToDom(this.props.el.contentDocument.body);

    parentVS.appendView(new Box({ data: "appendView", bg: "deepskyblue" }));

    parentVS.prependView(new Box({ data: "prependView", bg: "aqua" }));

    parentVS.appendViewAfter(
      new Box({ data: "appendViewAfter +", bg: "lightskyblue" }),
      "li:first-child",
    );

    return `   class Box extends ViewStream{
      constructor(props={}) {
        props.tagName="li";
        props.style=\`padding:.5rem;
        \u200Bmargin: .5rem 0;
        \u200Bbackground:$\u200B{props.bg};\`
        super(props);
      }
    }
    
    const parentVS = new ViewStream({
      tagName: 'ul',
      style: 'border:1px solid #666;'
    })
    
    parentVS.appendToDom(document.body);
    
    parentVS.appendView(new Box(
        {data:'appendView',
         bg:"deepskyblue"}))

    parentVS.prependView(new Box(
        {data:'prependView',
         bg:"aqua"}))

    parentVS.appendViewAfter(new Box(
        {data:'appendViewAfter +',
         bg:"lightskyblue"}),
            "li:first-child")
    
    
    
    `;
  }

  static codeplaygroundRef$ViewStreamPrependView(props = this.props) {
    class Box extends ViewStream {
      constructor(props = {}) {
        props.tagName = "li";
        props.style = `padding:.5rem;
        margin: .5rem 0;
        background:${props.bg}`;
        super(props);
      }
    }

    const parentVS = new ViewStream({
      tagName: "ul",
      style:
        "border:1px solid midnightblue;padding:.25rem .5rem; list-style-type:none;",
    });

    parentVS.appendToDom(this.props.el.contentDocument.body);

    parentVS.appendView(new Box({ data: "appendView", bg: "deepskyblue" }));

    parentVS.prependView(new Box({ data: "prependView +", bg: "aqua" }));

    return `   class Box extends ViewStream{
      constructor(props={}) {
        props.tagName="li";
        props.style=\`padding:.5rem;
        \u200Bmargin: .5rem 0;
        \u200Bbackground:$\u200B{props.bg};\`
        super(props);
      }
    }
    
    const parentVS = new ViewStream({
      tagName: 'ul',
      style: 'border:1px solid #666;'
    })
    
    parentVS.appendToDom(document.body);
    
    parentVS.appendView(new Box(
        {data:'appendView',
         bg:"deepskyblue"}))

    parentVS.prependView(new Box(
        {data:'prependView',
         bg:"aqua"}))

    
    `;
  }

  static codeplaygroundRef$ViewStreamPrependViewOld(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamAppendToDom(props = this.props) {
    const name = this?.props?.data?.name;

    const listItems = ["gray", "green", "gray"];

    new ViewStream({
      data: "appendToDom",
      style: `background:#5ED0FA;\npadding:.5rem;`,
    }).appendToDom(this.props.el.contentDocument.body);

    return `
    import {ViewStream} from 'spyne';
    
    new ViewStream({
      data:  "appendToDom",
      style: \`background:#5ED0FA;
              \u200Bpadding:.5rem;\
              \`
            }).appendToDom(document.body);       

  `;
  }

  static codeplaygroundRef$ViewStreamAppendToDomAfter(props = this.props) {
    const name = this?.props?.data?.name;

    const listItems = ["gray", "green", "gray"];

    /*
    new ViewStream({
      tagName: 'ul',
      data: {listItems},
      template: "{{#listItems}}<li class='box {{.*}}'></li>{{/listItems}}"

    }).appendToDom(this.props.el.contentDocument.body);


    const firstChildLi = this.props.el.contentDocument.body.querySelector("ul li.box.green");
    new ViewStream({data: "Hello World"})
    .appendToDomAfter(firstChildLi);

*/

    new ViewStream({
      data: "appendToDom",
      style: `background:#5ED0FA;\npadding:.5rem;`,
    }).appendToDom(this.props.el.contentDocument.body);

    new ViewStream({
      data: "prependToDom",
      style: `background:#c8f1fe;\npadding:.5rem;`,
    }).prependToDom(this.props.el.contentDocument.body);

    new ViewStream({
      data: `appendToDomAfter +`,
      style: `background:#98e2fb;\npadding:.5rem;`,
    }).appendToDomAfter(
      this.props.el.contentDocument.body.querySelector("div:first-child"),
    );

    return `
    import {ViewStream} from 'spyne';
    
    new ViewStream({
      data:  "appendToDom",
      style: \`background:#5ED0FA;
              \u200Bpadding:.5rem;\`
             }).appendToDom(document.body);       

    new ViewStream({
      data:  "prependToDom",
      style: \`background:#c8f1fe;
              \u200Bpadding:.5rem;\`
             }).prependToDom(document.body);

    new ViewStream({
      data:  "appendToDomAfter +",
      style: \`background:#D2E4F3;
              \u200Bpadding:.5rem;\`
             }).appendToDomAfter(
       document.body.querySelector(
        'div:first-child'
            ));

    `;
  }

  static codeplaygroundRef$ViewStreamAppendToNull(props = this.props) {
    const name = this?.props?.data?.name;

    class MyHiddenViewStream extends ViewStream {
      constructor() {
        super();
      }

      mySpecialMethods() {}
    }

    new MyHiddenViewStream().appendToNull();

    return `
   import {ViewStream} from 'spyne';
       
   class MyHiddenViewStream extends ViewStream {
 
     constructor() {
       super();
     }
   
     mySpecialMethods(){
       /**
       *
       * run code frm a
       * ViewStream instance that
       * should not be visible
       *
       */
     }
   
   }
     
     new MySpecialViewStream()
     .appendToNull();
    `;
  }

  static codeplaygroundRef$ViewStreamPrependToDom(props = this.props) {
    const name = this?.props?.data?.name;

    const listItems = ["gray", "green", "gray"];
    /*

    new ViewStream({
      tagName: 'ul',
      data: {listItems},
      template: "{{#listItems}}<li class='box {{.*}}'></li>{{/listItems}}"

    }).appendToDom(this.props.el.contentDocument.body);


    const firstChildLi = this.props.el.contentDocument.body.querySelector("ul li.box.green");
    new ViewStream({data: "Hello World"})
    .prependToDom(this.props.el.contentDocument.body);

*/

    new ViewStream({
      data: "appendToDom",
      style: `background:#5ED0FA;\npadding:.5rem;`,
    }).appendToDom(this.props.el.contentDocument.body);

    new ViewStream({
      data: "prependToDom +",
      style: `background:#B3ECFF;\npadding:.5rem;`,
    }).prependToDom(this.props.el.contentDocument.body);

    return `
    import {ViewStream} from 'spyne';
    
    new ViewStream({
      data:  "appendToDom",
      style: \`background:#5ED0FA;
              \u200Bpadding:.5rem;\`
             }).appendToDom(document.body);       

    new ViewStream({
      data:  "prependToDom +",
      style: \`background:#c8f1fe;
              \u200Bpadding:.5rem;\`
             }).prependToDom(document.body);


    `;
  }

  static codeplaygroundRef$ViewStreamDisposeViewStream(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamOnRendered(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamPropsEl(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamPropsElSelectorEls(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamPropsElSelectorLength(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamPropsElSelectorEl(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamPropsElSelectorArr(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamPropsElSelectorAddClass(
    props = this.props,
  ) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamPropsElSelectorRemoveClass(
    props = this.props,
  ) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamPropsElSelectorSetClass(
    props = this.props,
  ) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamPropsElSelectorToggle(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamPropsElSelectorSetActiveItem(
    props = this.props,
  ) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamPropsElSelectorExists(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamAddActionListeners(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamBroadcastEvents(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamSendInfoToChannel(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ViewStreamAddChannel(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$DomElementConstructor(props = this.props) {
    const name = this?.props?.data?.name;

    // Define the data
    const data = "Hello World";

    // Render using DomElementTemplate
    const html = new DomElement({data});

    this.props.el.contentDocument.body
    .appendChild(html.render());


    //this.props.el.contentDocument.body.appendChild(helloWorldContent.renderDocFrag());

    return `
  // Define the data
    const data = "Hello World";

    // Create the DomElement
    const html = new DomElement({data});


  // Append to body
    document.body.appendChild(html.render());
    
    `;
  }

  static codeplaygroundRef$DomElementRender(props = this.props) {
    const name = this?.props?.data?.name;

    return this.codeplaygroundRef$DomElementConstructor();

  }

  static codeplaygroundRef$DomElementTemplateConstructor(props = this.props) {
    const name = this?.props?.data?.name;

    // Define the template
    const template = "<p>{{text}}</p>";

    // Define the data
    const data = {text: "Hello World"};

    // Render using DomElementTemplate
    const html = new DomElementTemplate(
        template, data
    ).renderDocFrag();

    this.props.el.contentDocument.body
    .appendChild(html);


    //this.props.el.contentDocument.body.appendChild(helloWorldContent.renderDocFrag());

    return `
  // Define the template
  const template = "<p>{{text}}</p>";  

  // Define the data
  const data = {text: "Hello World"};

  // Render using DomElementTemplate
  const html = new DomElementTemplate(
      template, data
      ).renderDocFrag();

  // Append to body
    document.body.appendChild(html);
    
    `


    //return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$DomElementTemplateRenderDocFrag(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$DomElementTemplateRenderToString(
    props = this.props,
  ) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ChannelConstructor(props = this.props) {
    const name = this?.props?.data?.name;
    return `
    
    const myChannel = new MyChannel("CHANNEL_MY_CHANNEL");
    spyneApp.registerChannel(myChannel);
    
    `

    //return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ChannelOnRegistered(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ChannelGetChannel(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ChannelMergeChannels(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ChannelAddRegisteredActions(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ChannelSendChannelPayload(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ChannelOnViewStreamInfo(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ChannelFetchConstructor(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ChannelFetchUtilSubscribe(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ChannelPayloadConstructor(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ChannelPayloadClone(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$ChannelPayloadFilterConstructor(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$SpyneTraitConstructor(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$SpyneAppInit(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$SpyneAppPropertiesInit(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$SpyneAppPropertiesSetProp(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$SpyneAppPropertiesGetProp(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$SpyneAppPropertiesGetChannelActions(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$SpyneAppPropertiesGetChannelConfig(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$SpyneAppPropertiesGetNavLinks(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$SpyneAppRegisterChannel(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$SpyneAppRegisterPlugin(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$SpyneAppListChannels(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$SpyneAppListChannelActions(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$SpynePluginConstructor(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$SpynePluginOnRegistered(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$SpynePluginOnRendered(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$TemplateSecurityNote(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

  static codeplaygroundRef$TemplateNotSupported(props = this.props) {
    const name = this?.props?.data?.name;
    return this.codeplaygroundRef$Default(name);
  }

}
